<template>
  <slot />
</template>

<script>
/** 
 * @description Used to display standalone components, such as login page
 * @module layouts/empty 
 */

export default {}
</script>
